/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Changes_Saved_SuccessfullyInputs */

const en_changes_saved_successfully = /** @type {(inputs: Changes_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes saved successfully ✨`)
};

const es_changes_saved_successfully = /** @type {(inputs: Changes_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios guardados con éxito ✨`)
};

const fr_changes_saved_successfully = /** @type {(inputs: Changes_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifications enregistrées avec succès ✨`)
};

const de_changes_saved_successfully = /** @type {(inputs: Changes_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen erfolgreich gespeichert ✨`)
};

const ja_changes_saved_successfully = /** @type {(inputs: Changes_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更が正常に保存されました ✨`)
};

const zh_changes_saved_successfully = /** @type {(inputs: Changes_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更改已成功保存 ✨`)
};

const ar_changes_saved_successfully = /** @type {(inputs: Changes_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم حفظ التغييرات بنجاح ✨`)
};

const id_changes_saved_successfully = /** @type {(inputs: Changes_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan berhasil disimpan ✨`)
};

const it_changes_saved_successfully = /** @type {(inputs: Changes_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifiche salvate con successo ✨`)
};

const ru_changes_saved_successfully = /** @type {(inputs: Changes_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменения успешно сохранены ✨`)
};

const pt_changes_saved_successfully = /** @type {(inputs: Changes_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterações salvas com sucesso ✨`)
};

const ko_changes_saved_successfully = /** @type {(inputs: Changes_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변경 사항이 성공적으로 저장되었습니다 ✨`)
};

/**
* | output |
* | --- |
* | "Changes saved successfully ✨" |
*
* @param {Changes_Saved_SuccessfullyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const changes_saved_successfully = /** @type {((inputs?: Changes_Saved_SuccessfullyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Changes_Saved_SuccessfullyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_changes_saved_successfully(inputs)
	if (locale === "es") return es_changes_saved_successfully(inputs)
	if (locale === "fr") return fr_changes_saved_successfully(inputs)
	if (locale === "de") return de_changes_saved_successfully(inputs)
	if (locale === "ja") return ja_changes_saved_successfully(inputs)
	if (locale === "zh") return zh_changes_saved_successfully(inputs)
	if (locale === "ar") return ar_changes_saved_successfully(inputs)
	if (locale === "id") return id_changes_saved_successfully(inputs)
	if (locale === "it") return it_changes_saved_successfully(inputs)
	if (locale === "ru") return ru_changes_saved_successfully(inputs)
	if (locale === "pt") return pt_changes_saved_successfully(inputs)
	return ko_changes_saved_successfully(inputs)
});